import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from './getOrganization';

export const getActivityCodes = createSelector(getOrganization, function (organization): string[] {
  if (organization === undefined) return [];
  return organization.activityCodes;
});

export const activityCodesByName = {
  crafts: '43',
  transportationAndStorage: 'H',
  cleaning: '81.21',
  hotel: '55.10',
  restaurant: '56.101',
  pub: '56.3',
  shop: '47',
  hairdressing: '96.02',
  gym: '93.130',
  adventures: '93.291',
};
